import MAlert from './Alert.vue';

export default MAlert;
